const gtmRegister = (info, th) => {
  const { category, action, label } = info;
  th.$analytics.trackEvent(category, action, label);
};

export default gtmRegister;
